import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { FetchProcedureWithPresentedDocumentationCommandHandler } from '@/Application/Documentation/Presented'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'
import { AxiosPresentedDocumentationRepository } from '@/Infrastructure/Documentation/Presented/Persistence/Axios'

export class FetchProcedureWithPresentedDocumentationCommandHandlerProvider
implements CommandHandlerProvider<FetchProcedureWithPresentedDocumentationCommandHandler> {
  provide (): FetchProcedureWithPresentedDocumentationCommandHandler {
    const handler = new FetchProcedureWithPresentedDocumentationCommandHandler(
      this.buildRepository()
    )
    return handler
  }

  private buildRepository () {
    const apiClient = new AxiosApiClient(new SessionTokenStorage())
    return new AxiosPresentedDocumentationRepository(apiClient)
  }
}
